<template>
  <breadcrumb :links="links"></breadcrumb>

  <div>
    <div class="section section_even">
      <div class="container-xl pt-2">
        <h1 class="main_title">{{ station.name }} - {{ sensor.name }}</h1>
        <div class="main_title_note">Misure automatiche non validate, tempi riferiti all'ora locale</div>
        <div class="row">
          <div class="col-md-1 col-sm-1 col-xs-12 text-end pt-1">
            <label for="fromDate">Dal</label>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <input ref="fromDateInput" class="form-control" type="date" :value="fromTime2HtmlDate(from)" />
          </div>
          <div class="col-md-2 col-sm-5 col-xs-12">
            <input ref="fromTimeInput" class="form-control" type="time" :value="fromTime2HtmlTime(from)" />
          </div>
          <div class="col-md-1 col-sm-1 col-xs-12 text-end pt-1">
            <label for="toDate">Al</label>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <input ref="toDateInput" class="form-control" type="date" :value="fromTime2HtmlDate(to)" />
          </div>
          <div class="col-md-2 col-sm-5 col-xs-12">
            <input ref="toTimeInput" class="form-control" type="time" :value="fromTime2HtmlTime(to)" />
          </div>
          <div class="col-sm-8 pt-1">
            <div class="alert alert-danger p-1" v-if="errorMsg">
              <i class='bi bi-exclamation-triangle-fill'></i> {{ errorMsg }}
            </div>
          </div>
          <div class="col-sm-4 text-end pt-1" id="reloadMeasures">
            <button type="button" class="btn btn-primary" v-on:click="updateMeasures()"><i
                class='bi bi-arrow-clockwise'></i> Carica i dati</button>
          </div>
        </div>
      </div>
    </div>

    <div class="section section_odd">
      <div class="container-xl pt-2">
        <h2>Grafico</h2>
        <div>
          <canvas id="measures_chart" width="400" height="400"></canvas>
        </div>
      </div>
    </div>

    <div class="section section_even">
      <div class="container-xl pt-2 measures_list">
        <h2>
          Tabella
          <div class="btn-group">
            <button type="button" class="btn btn-primary dropdown-toggle" id="downloadMeasures" data-bs-toggle="dropdown"
              aria-expanded="false">
              Scarica dati in formato CSV
            </button>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="#" v-on:click.prevent="downloadCsv(measures, 'selezionate')">Dati
                  visualizzati</a></li>
              <li><a class="dropdown-item" href="#" v-on:click.prevent="retriveAndDownloadCsv()">Dati ultimo mese</a></li>
            </ul>
          </div>
        </h2>
        <Table :columns="fields" :rows="measures" sort_field="dt" :sort_asc="true">
          <template #cell[dt]="{ row }">
            {{ convertTime(row.dt) }}
          </template>
          <template #cell[value]="{ row }">
            {{ formatMeasure(row.value, sensor.decimals) }} <small>{{ sensor.unit }}</small>
          </template>
        </Table>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</template>

<script>
import MonitorApi from '@/services/MonitorApi';
import Chart from 'chart.js/auto';
import Labels from '@/utils/labels';
import Table from '@/lib/table.vue'
import AppFooter from '@/app-footer.vue'
import Breadcrumb from '@/components/Breadcrumb'
import {ref} from 'vue';

  import chartjs_background_color from '@/utils/chartjs_background_color'

  export default {
    name: "measures",
    mixins: [Labels],
    components: {Table, AppFooter, Breadcrumb},
    data: function() {
      return {
        station: {},
        sensor: {},
        measures: [],
        links: {'/': 'Home', '/stazioni': 'Stazioni'},
        fields: [{id: 'dt', label: "Data, Ora", sortable: true}, {id: 'value', label: "Valore", sortable: true}],
        from: new Date(new Date() - 3600000 * 72),
        to: new Date(),
        errorMsg: undefined
      }
    },
    methods: {
      retriveAndDownloadCsv: async function() {
        const time = new Date();
        time.setMonth(time.getMonth() - 1);
        time.setDate(1);
        time.setHours(0);
        time.setMinutes(0);
        time.setSeconds(0);
        time.setMilliseconds(0);
        const measures = await MonitorApi.getSensorMeasures(this.$route.params.station_id, this.$route.params.sensor_id, time.toISOString());
        this.downloadCsv(measures, 'ultimo_mese');
      },

      downloadCsv(measures, suffix) {
        let csv = 'Data,Ora,Misura,Unità\n';
        const me = this;
        measures.forEach(function (measure) {
          csv += [me.convertTime(measure.dt), me.formatMeasure(measure.value, me.sensor.decimals), me.sensor.unit].join(',');
          csv += "\n";
        });

        const hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'misure_' + suffix + '.csv';
        hiddenElement.click();
      },
      updateMeasures() {
        this.errorMsg = undefined;
        const fromDate = this.fromDateInput.valueAsDate;
        const fromTime = this.fromTimeInput.valueAsDate;
        fromDate.setHours(fromTime.getUTCHours());
        fromDate.setMinutes(fromTime.getMinutes());
        const toDate = this.toDateInput.valueAsDate;
        const toTime = this.toTimeInput.valueAsDate;
        toDate.setHours(toTime.getUTCHours());
        toDate.setMinutes(toTime.getMinutes());

        const range = toDate - fromDate
        if (range < 0) {
          this.errorMsg = "La data/ora di fine deve essere maggiore di quella di inizio"
          return false;
        }
        else if (range > (3600000 * 7 * 24)) {
          this.errorMsg = "L'intervallo massimo è di 7 giorni"
          return false;
        }

        this.from = fromDate;
        this.to = toDate;

          return true;
      },
      loadMeasures: async function() {
        this.measures = await MonitorApi.getSensorMeasures(this.$route.params.station_id, this.$route.params.sensor_id, this.from.toISOString(), this.to.toISOString());
        const labels = this.measures.map(m => this.convertTime(m.dt));
        const values = this.measures.map(m => this.formatMeasure(m.value, this.sensor.decimals));
        const day_stops = labels.flatMap((label, i) => (label.substring(11) == '00:00:00' || label.substring(10) == '00:00:00') ? i/(labels.length-1) : []);
        if(this.chart)
          this.chart.destroy();
        this.chart = new Chart('measures_chart', {
          plugins: [chartjs_background_color],
          type: 'line',
          data: {
            labels: labels,
            datasets: [{
              label: this.sensor.unit,
              data: values,
              fill: false,
              lineTension: 0,
              borderColor: "#F06D16",
              backgroundColor: "#F06D16",
              pointBackgroundColor: "#F06D1644",
              pointRadius: 2,
              borderWidth: 1.5
            }]
          },
          options: {
            maintainAspectRatio: false,
            responsive: true,
            chart: {
            },
            animation: {
              duration: 0
            },
            plugins: {
              chartjs_background_color: {
                stops: day_stops,
                color: "#E5E5E5"
              }
            }
          }
        });
    }
  },
  mounted: async function () {
    this.station = await MonitorApi.getStation(this.$route.params.station_id);
    const sensors = await MonitorApi.getStationSensors(this.$route.params.station_id);
    for (let i = 0; i < sensors.length; i++) {
      const sensor = sensors[i];
      if (sensor.id == this.$route.params.sensor_id) {
        this.sensor = sensor;
        break;
      }
    }
    this.links['/stazione/' + this.$route.params.station_id] = this.station.name;
    this.links['current'] = this.sensor.name;
    await this.loadMeasures();
  }
}
</script>

<style lang="scss" scoped>
.measures_list {
  .btn-group {
    float: right;
  }

  table {
    width: 100%;
  }
}

.main_title {
  margin-bottom: 0 !important;
  padding-bottom: 0;
}

.main_title_note {
  font-size: 0.8em;
  font-style: italic;
  margin-bottom: 10px;
}

@media print {

  #reloadMeasures,
  #downloadMeasures {
    display: none;
  }

  .measures_list {
    table td {
      padding: 0;
    }
  }
}</style>